

import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { ODataTable, FilterTypes, QueryOptions } from 'framework-ui-components';

import TipoDichiarazione from 'enums/TipoDichiarazione';
import { annullaElimina, creaSetteTrentaIntegrativa } from 'apis/setteTrentaApi';
import ModaleCreazione from './ModaleCreazione';
import StatiRicerca from '../../enums/StatiRicerca';

class ElasticTable extends Component {
  state = {
    mostraModaleCreazione: false,
    isLoadingModaleCreazione: false,
    messaggioErroreCreazione: null,
  }

  loadPage = () => {
    this.dataTable && this.dataTable.loadPage();
  }

  urlCorrente = () => this.dataTable && this.dataTable.urlCorrente();

  getItems = () => this.dataTable && this.dataTable.state.items

  getSelezionati = () => {
    const { annoSelezionato } = this.props;
    return this.dataTable && this.dataTable.selezionati().filter(z => annoSelezionato > 2019 || z.Stato != 6);
  }

  apriModaleCreazioneIntegrativa = (dichiarazione) => {
    dichiarazione.TipoDichiarazione = ModaleCreazione.TipoDichiarazione.INTEGRATIVA;
    this.setState({ mostraModaleCreazione: true, datiInizialiModale: dichiarazione });
  }

  chiudiModaleCreazione = () => {
    this.setState({
      mostraModaleCreazione: false, isLoadingModaleCreazione: false, datiInizialiModale: null, messaggioErroreCreazione: null,
    });
  }

  pulisciSelezione = () => {
    this.dataTable.pulisciSelezione();
  }

  creaNuovaDichiarazione = (data) => {
    if (data.TipoDichiarazione != TipoDichiarazione.Ordinaria) {
      this.setState({ isLoadingModaleCreazione: true }, () => {
        const { ufficio, annoSelezionato } = this.props;

        const cmd = {
          Studio: ufficio,
          CodiceFiscale: data.CodiceFiscale.trim().toUpperCase(),
          Nome: data.Nome.trim().toUpperCase(),
          Cognome: data.Cognome.trim().toUpperCase(),
          TipoDichiarazione: data.TipoDichiarazione,
          Protocollo: data.Protocollo,
          Anno: annoSelezionato,
        };
        if (data.TipoDichiarazione == TipoDichiarazione.SetteTrentaIntegrativaCodice2) {
          cmd.SenzaSostituto = data.SceltaSostituto == 0;
          cmd.IBAN = data.SceltaSostituto == 0 ? data.CodiceIban : null;
          cmd.IdSostitutoImposta = data.Sostituto ? data.Sostituto.IdSostituto : null;
          cmd.DataPrimaRata = data.DataPrimaRata;
        }

        creaSetteTrentaIntegrativa(cmd)
          .then((resp) => {
            if (!resp.Success) {
              this.setState({ messaggioErroreCreazione: resp.DetectedProblems });
            } else {
              this.chiudiModaleCreazione();
            }

            this.setState({ isLoadingModaleCreazione: false });
          });
      });
    }
  }

  ripristinaEliminata = (data) => {
    const { annoSelezionato, anniRegistrati } = this.props;
    this.setState({ isLoadingModaleCreazione: true }, () => {
      annullaElimina(data.dichiarazioneEsistente.IdDichiarazione, annoSelezionato)
        .then((res) => {
          if (res.Success) {
            const url = anniRegistrati.filter(x => x.Anno == annoSelezionato)[0].Url730;
            window.location.href = `${url}#/Frontespizio/${data.dichiarazioneEsistente.IdDichiarazione.split('/')[1]}`;
            this.chiudiModaleCreazione();
          } else {
            this.setState({ messaggioErroreCreazione: res.DetectedProblems });
          }

          this.setState({ isLoadingModaleCreazione: false });
        });
    });
  }

  filtriStati(tabNr) {
    let filters = [];

    if (tabNr == 0 || tabNr == 1) {
      filters = filters.concat([
        { description: 'Anno Precedente', value: '5' },
        { description: 'In Lavorazione / Errate', value: '20' },
        { description: 'Bloccata CAF', value: '110' },
      ]);
    }

    if (tabNr == 0 || tabNr == 2) {
      filters = filters.concat([
        { description: 'Completa', value: '30' },
        { description: 'Annullata', value: '0' },
        { description: 'Annullata A.E.', value: '90' },
        { description: 'Bloccata Integrativo', value: '111' },
      ]);
    }

    if (tabNr == 0 || tabNr == 3) {
      filters = filters.concat([
        { description: 'Controllo Audit', value: '31' },
        { description: 'Trasmessa CGN', value: '40' },
        { description: 'Inviata A.E.', value: '41' },
        { description: 'Ricevuta A.E', value: '60' },
        { description: 'Da Annullare A.E', value: '80' },
      ]);
    }

    if (tabNr == 0 || tabNr == 4) {
      filters = filters.concat([
        { description: 'Scartata Audit', value: '104' },
        { description: 'Scartata C.F.', value: '100' },
        { description: 'Scartata A.E.', value: '103' },
        { description: 'Scartata Precompilato', value: '101' },
        { description: 'Scartata Ricalcolo', value: '102' },
      ]);
    }


    return filters;
  }

  render() {
    // TODO togliere il condizionale sulla tabella appena risolto il bug della odatatable
    const {
      row, searchTerm, statoRicerca, onSelezionati, onPageLoad, ufficio, tabNr, annoSelezionato, anniRegistrati, store, impostazioni, scaricaRicevutaAdE,
    } = this.props;

    const {
      datiInizialiModale, mostraModaleCreazione, isLoadingModaleCreazione, messaggioErroreCreazione,
    } = this.state;

    const filters = this.filtriStati(tabNr);

    const additionalFilters = [
      {
        propertyName: 'Tipo', descriptions: 'Tipo', component: FilterTypes.SELECT, query: QueryOptions.EQUAL, options: [{ description: 'Ordinaria', value: '0' }, { description: 'Integrativa 1', value: '16' }, { description: 'Integrativa 2', value: '17' }, { description: 'Integrativa 3', value: '18' }],
      },
      {
        propertyName: 'Stato', descriptions: 'Stato', component: FilterTypes.SELECT, query: QueryOptions.EQUAL, options: filters,
      },
      {
        propertyName: 'Segnalibro', descriptions: 'Segnalibro', component: FilterTypes.INPUT, query: QueryOptions.STRING_EQUAL,
      },
    ];

    if (tabNr === 3 || tabNr === 0) {
      additionalFilters.push({
        propertyName: 'Stampata',
        description: 'Stampa 730',
        component: FilterTypes.SELECT,
        query: QueryOptions.STRING_EQUAL,
        options: [
          { description: 'Stampate', value: 'True' }, { description: 'Non stampate', value: 'False' },
        ],
      });
    }

    return (
      <Fragment>
        {
          (tabNr == 3 || tabNr == 0)
            ? (
              <ODataTable
                hover
                clickable
                url={annoSelezionato != 0 ? `/SetteTrenta/CercaSetteTrenta?searchTerm=${searchTerm}&searchType=${statoRicerca}&ufficio=${ufficio}&anno=${annoSelezionato}` : null}
                row={row}
                selectable
                sortProperty="Dichiarante"
                ref={r => this.dataTable = r}
                onSelezionati={onSelezionati}
                onPageLoad={onPageLoad}
                pageSize={10}
                additionalFilters={additionalFilters}
                availablePageSizes={[10, 50, 100]}
                additionalRowData={{
                  onApriModaleIntegrativa: this.apriModaleCreazioneIntegrativa, searchTerm, tabNr, impostazioni, scaricaRicevutaAdE,
                }}
                store={store}
              >
                <ODataTable.Column propertyName="Dichiarante">Dichiarante</ODataTable.Column>
                <ODataTable.Column propertyName="Coniuge">Coniuge</ODataTable.Column>
                <ODataTable.Column propertyName="Tipologia">Tipologia</ODataTable.Column>
                <ODataTable.Column propertyName="SostitutoImposta">Sostituto</ODataTable.Column>
                <ODataTable.Column className="w-140">Stato</ODataTable.Column>
                <ODataTable.Column propertyName="Tipo" className="w-100">Tipo</ODataTable.Column>
                <ODataTable.Column className="w-140">Segnalibro</ODataTable.Column>
                <ODataTable.Column className="w-100">Stampata</ODataTable.Column>
                <ODataTable.Column propertyName="DataUltimaModifica" className="w-140">Ultima modifica</ODataTable.Column>
                <ODataTable.Column className="w-70">Note</ODataTable.Column>
                <ODataTable.Column className="w-40" />
                <ODataTable.Column className="w-40" />
              </ODataTable>
            )
            : (
              <ODataTable
                hover
                clickable
                url={annoSelezionato != 0 ? `/SetteTrenta/CercaSetteTrenta?searchTerm=${searchTerm}&searchType=${statoRicerca}&ufficio=${ufficio}&anno=${annoSelezionato}` : null}
                row={row}
                selectable
                sortProperty="Dichiarante"
                ref={r => this.dataTable = r}
                onSelezionati={onSelezionati}
                onPageLoad={onPageLoad}
                pageSize={10}
                additionalFilters={[
                  {
                    propertyName: 'Tipo', descriptions: 'Tipo', component: FilterTypes.SELECT, query: QueryOptions.EQUAL, options: [{ description: 'Ordinaria', value: '0' }, { description: 'Integrativa 1', value: '16' }, { description: 'Integrativa 2', value: '17' }, { description: 'Integrativa 3', value: '18' }],
                  },
                  {
                    propertyName: 'Stato', descriptions: 'Stato', component: FilterTypes.SELECT, query: QueryOptions.EQUAL, options: filters,
                  },
                  {
                    propertyName: 'Segnalibro', descriptions: 'Segnalibro', component: FilterTypes.INPUT, query: QueryOptions.STRING_EQUAL,
                  },
                ]}
                availablePageSizes={[10, 50, 100]}
                additionalRowData={{
                  onApriModaleIntegrativa: this.apriModaleCreazioneIntegrativa, searchTerm, tabNr, impostazioni,
                }}
                store={store}
              >
                <ODataTable.Column propertyName="Dichiarante">Dichiarante</ODataTable.Column>
                <ODataTable.Column propertyName="Coniuge">Coniuge</ODataTable.Column>
                <ODataTable.Column propertyName="Tipologia">Tipologia</ODataTable.Column>
                <ODataTable.Column propertyName="SostitutoImposta">Sostituto</ODataTable.Column>
                <ODataTable.Column className="w-140">Stato</ODataTable.Column>
                <ODataTable.Column propertyName="Tipo" className="w-100">Tipo</ODataTable.Column>
                <ODataTable.Column className="w-140">Segnalibro</ODataTable.Column>
                <ODataTable.Column propertyName="DataUltimaModifica" className="w-140">Ultima modifica</ODataTable.Column>
                <ODataTable.Column className="w-70">Note</ODataTable.Column>
                <ODataTable.Column className="w-40" />
                <ODataTable.Column className="w-40" />
              </ODataTable>
            )
        }

        {mostraModaleCreazione && (
          <ModaleCreazione
            showModal
            anniRegistrati={anniRegistrati}
            isLoading={isLoadingModaleCreazione}
            tipoDichiarazione={ModaleCreazione.TipoDichiarazione.INTEGRATIVA}
            messaggioErrore={messaggioErroreCreazione}
            onAnnulla={this.chiudiModaleCreazione}
            onCreaNuova={this.creaNuovaDichiarazione}
            onRipristinaEliminata={this.ripristinaEliminata}
            ufficioSelezionato={ufficio}
            datiIniziali={datiInizialiModale}
            annoSelezionato={annoSelezionato}
            impostazioni={impostazioni}
          />
        )
        }
      </Fragment>
    );
  }
}

ElasticTable.propTypes = {
  anniRegistrati: PropTypes.array,
  onSelezionati: PropTypes.func,
  row: PropTypes.func,
  searchTerm: PropTypes.string,
  statoRicerca: PropTypes.string,
  ufficio: PropTypes.string,
  tabNr: PropTypes.number,
  annoSelezionato: PropTypes.number,
  store: PropTypes.string,
};

ElasticTable.StatiRicercaSetteTrenta = StatiRicerca;

export default ElasticTable;
